import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { myI18n } from 'translation/I18nConnectedProvider'
import { pdfTableCellTextStyle, pdfTableHelpTextStyle, pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'

const styles = {
  ...pdfTableStyles,
  // Font-less text styles, so the font picked for the language in FormPdf is inherited
  tableCell: pdfTableCellTextStyle,
  helptextCell: pdfTableHelpTextStyle,
  ...StyleSheet.create({
    firstRow: {
      justifyContent: 'center',
      fontWeight: 'bold'
    },
    firstCol: {
      justifyContent: 'center',
      width: '35%'
    },
    secondCol: {
      width: '15%'
    },
    thirdCol: {
      width: '50%'
    },
    tableCol: {
      ...pdfTableStyles.tableCol,
      minHeight: 35
    },
    mainTableCell: {
      ...pdfTableCellTextStyle,
      fontWeight: 'bold'
    }
  })
}

export const FormBudgetFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  altLabelPlacement,
  ...props
}) => {
  const expenses = typeProps.expensesLines || []
  const revenues = typeProps.revenuesLines || []
  const expensesHelpText = typeProps?.expensesHelpText?.[langVersion] || ''
  const revenuesHelpText = typeProps?.revenuesHelpText?.[langVersion] || ''

  return (
    <View style={styles.table}>
      <View style={styles.tableRow} wrap={false}>
        <View style={[styles.tableCol, styles.firstCol, styles.firstRow]}>
          <Text style={styles.mainTableCell}>{myI18n._(t`Revenues`)}</Text>
          {revenuesHelpText
            ? (
              <Text style={styles.helptextCell}>{revenuesHelpText}</Text>
              )
            : null}
        </View>
        <View style={[styles.tableCol, styles.secondCol, styles.firstRow]}>
          <Text style={styles.tableCell}>{myI18n._(t`Amount`)}</Text>
        </View>
        <View style={[styles.tableCol, styles.thirdCol, styles.firstRow]}>
          <Text style={styles.tableCell}>{myI18n._(t`Comments`)}</Text>
        </View>
      </View>

      {revenues.map((item, index) => (
        <View style={styles.tableRow} wrap={false} key={index}>
          <View style={[styles.tableCol, styles.firstCol]}>
            <Text style={styles.tableCell}>{myI18n._(item)}</Text>
          </View>
          <View style={[styles.tableCol, styles.secondCol]} />
          <View style={[styles.tableCol, styles.thirdCol]} />
        </View>
      ))}

      <View style={styles.tableRow} wrap={false}>
        <View style={[styles.tableCol, styles.firstCol]}>
          <Text style={styles.mainTableCell}>
            {myI18n._(t`SUM_OF_REVENUES`)}
          </Text>
        </View>
        <View style={[styles.tableCol, styles.secondCol]} />
        <View style={[styles.tableCol, styles.thirdCol]} />
      </View>

      <View style={styles.tableRow} wrap={false}>
        <View style={[styles.tableCol, styles.firstCol]}>
          <Text style={styles.mainTableCell}>{myI18n._(t`Expenses`)}</Text>
          {expensesHelpText
            ? (
              <Text style={styles.helptextCell}>{expensesHelpText}</Text>
              )
            : null}
        </View>
        <View style={[styles.tableCol, styles.secondCol]} />
        <View style={[styles.tableCol, styles.thirdCol]} />
      </View>

      {expenses.map((item, index) => (
        <View style={styles.tableRow} wrap={false} key={index}>
          <View style={[styles.tableCol, styles.firstCol]}>
            <Text style={styles.tableCell}>{myI18n._(item)}</Text>
          </View>
          <View style={[styles.tableCol, styles.secondCol]} />
          <View style={[styles.tableCol, styles.thirdCol]} />
        </View>
      ))}

      <View style={styles.tableRow} wrap={false}>
        <View style={[styles.tableCol, styles.firstCol]}>
          <Text style={styles.mainTableCell}>
            {myI18n._(t`SUM_OF_EXPENSES`)}
          </Text>
        </View>
        <View style={[styles.tableCol, styles.secondCol]} />
        <View style={[styles.tableCol, styles.thirdCol]} />
      </View>
    </View>
  )
}
